import style from '../Home.module.scss';
import className from 'classnames/bind';
import {Image} from "../../../components";
import {numberFormat} from "../../../utils";
import DashboardWidgetHeader from "./DashboardWidgetHeader";

const cn = className.bind(style);

const CARD_GRADIENTS = {
	'card-green':  'linear-gradient(135deg, #1a7a5a 0%, #249872 100%)',
	'card-blue':   'linear-gradient(135deg, #1e4a7a 0%, #2f5e95 100%)',
	'card-red':    'linear-gradient(135deg, #b91c1c 0%, #dc2626 100%)',
	'card-theme':  'linear-gradient(135deg, #b91c1c 0%, #dc2626 100%)',
	'card-violet': 'linear-gradient(135deg, #503E9D 0%, #7c5dc7 100%)',
	'card-yellow': 'linear-gradient(135deg, #b45309 0%, #e47d0a 100%)',
};

const CardRanks = ({name, items, cardColor, bgImage, icon = 'fa-light fa-trophy'}) => {
	const gradient = CARD_GRADIENTS[cardColor] || CARD_GRADIENTS['card-theme'];

	return (
		<div className={cn('card', 'card-ranks', cardColor)} style={{padding: 0, overflow: 'hidden'}}>
			<DashboardWidgetHeader icon={icon} title={name} gradient={gradient} />
			<div style={{padding: 20}}>
				<div className={cn('list-ranks')}>
					{items.map((item) => (
						<div key={`card-rank-${item.id}`} className={cn('user', 'd-flex', 'gap', 'align-items')}>
							<div className={cn('medal')}><small></small></div>
							<div className={cn('avatar-rank', 'avatar')}><Image src={item.avatar} /></div>
							<div className={cn('info')}>
								<b className={cn('name')}>{item.firstname} {item.lastname}</b>
								<p className={cn('info-more')}>{item.username}</p>
								<p className={cn('revenue')}>{numberFormat(item.total)}</p>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default CardRanks;
